/**
 * Node.js polyfills for the browser
 */
export const process = require("process");
export const util = require("util");
